var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTetherReHorizLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 216 72",
    style: {
      enableBackground: "new 0 0 216 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#65ACD5;}\n\t.st1{fill:#21496C;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194.5,32.09v-8.93c0-0.11,0.08-0.19,0.19-0.19h3.41c2,0,3.08,1.17,3.08,2.85v0.39 c0,1.12-0.52,2.02-1.46,2.49l1.82,3.35c0.06,0.13,0.01,0.23-0.13,0.23h-1.98c-0.1,0-0.18-0.04-0.23-0.14l-1.55-3.07h-0.99v3.02 c0,0.11-0.08,0.19-0.19,0.19h-1.77C194.58,32.28,194.5,32.21,194.5,32.09z M197.94,27.23c0.75,0,1.09-0.39,1.09-1.03v-0.27 c0-0.65-0.34-1.04-1.09-1.04h-1.29v2.34H197.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M202.99,32.09v-8.93c0-0.11,0.08-0.19,0.19-0.19h5.46c0.11,0,0.19,0.08,0.19,0.19v1.54 c0,0.11-0.08,0.19-0.19,0.19h-3.5v1.73h3.13c0.11,0,0.19,0.08,0.19,0.19v1.46c0,0.11-0.08,0.19-0.19,0.19h-3.13v1.9h3.52 c0.11,0,0.19,0.08,0.19,0.19v1.54c0,0.11-0.08,0.19-0.19,0.19h-5.48C203.07,32.28,202.99,32.21,202.99,32.09z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67.56,26.43h-5.39v14.59h-5.33V26.43h-5.39v-4.64h16.11V26.43z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.09,41.02H76.16V21.79H90.9v4.48h-9.46v2.55h5.69v4.42h-5.69v3.3h9.65 C91.09,36.54,91.09,41.02,91.09,41.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M115.32,26.43h-5.39v14.59h-5.33V26.43h-5.4v-4.64h16.11v4.64H115.32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140.8,41.02h-5.44v-7.58h-5.99v7.58h-5.44V21.79h5.44v7h5.99v-7h5.44V41.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M165.14,41.02h-14.93V21.79h14.74v4.48h-9.46v2.55h5.69v4.42h-5.69v3.3h9.65L165.14,41.02L165.14,41.02z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M190.54,41.02h-5.97l-3.13-6.48h-2.14v6.48h-5.25V21.79h8.61c4.51,0,7.51,1.7,7.51,6.26 c0,2.88-1.35,4.67-3.46,5.63L190.54,41.02z M184.85,28.19c0-1.21-0.66-2.06-2.34-2.06h-3.22v4.2h3.13 C184.16,30.33,184.85,29.56,184.85,28.19z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.27,36.15c0.23-1.08,0.28-2.09,0.28-2.09c0-0.48,0-0.96,0-1.45c1.02,0,2.05,0,3.07,0L30.06,21.06 c-0.71,0.78-1.43,1.56-2.14,2.34c0.48,0.5,0.97,1.01,1.45,1.51c0.23-0.25,0.46-0.5,0.69-0.75l6.56,7.18c-0.37,0-0.75,0-1.12,0 c0.01,1.71,0.01,3.42,0.02,5.13c-0.03,1.51-0.05,3.02-0.08,4.53C35.65,40.61,36.82,38.32,37.27,36.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.81,32.84c-0.02,0.43-0.02,0.88,0,1.34c0.13,2.96,1.13,5.4,2.11,7.16c0.01-2.98,0.03-5.96,0.04-8.94v-0.84 c-0.39,0-0.79,0-1.18,0l6.92-7.18l6.9,7.16h-1.18h-0.01l0,0H29.4c0,5.25,0,10.49,0,15.74c0.72-0.72,1.44-1.45,2.16-2.17 c0.01-4.09,0.01-8.18,0.02-12.27c1.08,0,2.17,0,3.25,0L23.7,21.28L12.56,32.84C13.64,32.84,14.73,32.84,15.81,32.84z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "26.71,21.63 28.21,20.08 25.24,20.08  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.38,20.08H10.6v9.4h1.78v0.01c3.14-3.14,6.28-6.27,9.41-9.41c-3.14,0-6.28,0.01-9.41,0.01 C12.38,20.09,12.38,20.08,12.38,20.08z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.17,20.09c-2.94,0-5.88,0.01-8.82,0.01c2.93,3.14,5.87,6.28,8.8,9.42c0.01,0,0.01,0,0.02,0h1.78v-9.43 H41.17z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.95,35.61c0-0.21,0-0.42-0.01-0.62c-0.01-0.18-0.16-0.32-0.35-0.32h-2.27c-0.2,0-0.35,0.15-0.35,0.34 c0.11,4.02-1.65,7.68-4.47,10.23c-2.91,2.71-5.82,5.41-8.73,8.12c-2.91-2.71-5.82-5.41-8.73-8.12c-2.82-2.56-4.58-6.22-4.47-10.23 c0.01-0.19-0.15-0.34-0.35-0.34h-2.27c-0.19,0-0.34,0.14-0.35,0.32c-0.01,0.21-0.01,0.41-0.01,0.62c0,4.49,1.93,8.56,5.06,11.48 l0,0l11.12,10.15L37.89,47.1l0,0C41.01,44.17,42.95,40.11,42.95,35.61z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 20.67,
    y: 32.03,
    className: "st0",
    width: 2.25,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.47,
    y: 32.03,
    className: "st0",
    width: 2.25,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.67,
    y: 35.72,
    className: "st0",
    width: 2.25,
    height: 2.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.47,
    y: 35.72,
    className: "st0",
    width: 2.25,
    height: 2.25
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M56.37,52.55v-6.36h2.49c1.22,0,2.01,0.62,2.01,1.76v0.17c0,1.05-0.65,1.65-1.68,1.75l1.71,2.68h-0.74 l-1.68-2.66h-1.48v2.66H56.37z M56.98,49.34h1.86c0.84,0,1.38-0.4,1.38-1.22v-0.17c0-0.82-0.54-1.22-1.38-1.22h-1.86V49.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.97,52.55v-6.36h4.09v0.55h-3.48v2.28h3.19v0.55h-3.19V52h3.5v0.55H61.97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M71.82,52.55l-0.71-1.84h-2.96l-0.72,1.84h-0.63l2.51-6.36h0.66l2.5,6.36H71.82z M68.36,50.16h2.53l-1.26-3.28 L68.36,50.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.46,52.55v-6.36h0.62V52h2.88v0.55H73.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.87,52.55v-6.36h4.09v0.55h-3.48v2.28h3.19v0.55h-3.19V52h3.5v0.55H79.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M84.8,50.66h0.64c0.1,1.02,0.87,1.44,1.85,1.44c0.89,0,1.64-0.41,1.64-1.2v-0.09c0-0.66-0.55-0.99-1.82-1.23 c-1.52-0.27-2.07-0.8-2.07-1.68v-0.09c0-0.95,0.83-1.73,2.12-1.73c1.22,0,2.13,0.61,2.28,1.79h-0.63 c-0.13-0.81-0.75-1.25-1.66-1.25c-0.88,0-1.5,0.45-1.5,1.17v0.09c0,0.62,0.48,0.95,1.65,1.15c1.44,0.23,2.25,0.71,2.25,1.76v0.09 c0,1-0.86,1.77-2.3,1.77C85.88,52.65,84.88,51.96,84.8,50.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.94,52.55v-5.81h-1.99v-0.55h4.6v0.55h-2v5.81H91.94z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.14,52.55l-0.71-1.84h-2.96l-0.72,1.84h-0.63l2.51-6.36h0.66l2.5,6.36H99.14z M95.68,50.16h2.53l-1.26-3.28 L95.68,50.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M101.37,52.55v-5.81h-1.99v-0.55h4.6v0.55h-2v5.81H101.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.04,52.55v-6.36h4.09v0.55h-3.48v2.28h3.19v0.55h-3.19V52h3.5v0.55H105.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.06,50.66h0.64c0.1,1.02,0.87,1.44,1.85,1.44c0.89,0,1.64-0.41,1.64-1.2v-0.09c0-0.66-0.55-0.99-1.82-1.23 c-1.52-0.27-2.07-0.8-2.07-1.68v-0.09c0-0.95,0.83-1.73,2.12-1.73c1.22,0,2.13,0.61,2.28,1.79h-0.63 c-0.13-0.81-0.75-1.25-1.66-1.25c-0.88,0-1.5,0.45-1.5,1.17v0.09c0,0.62,0.48,0.95,1.65,1.15c1.44,0.23,2.25,0.71,2.25,1.76v0.09 c0,1-0.86,1.77-2.3,1.77C113.13,52.65,112.14,51.96,112.06,50.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M122.4,52.55l-0.71-1.84h-2.96l-0.72,1.84h-0.63l2.51-6.36h0.66l2.5,6.36H122.4z M118.94,50.16h2.54 l-1.26-3.28L118.94,50.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.04,52.55v-6.36h3.86v0.55h-3.24v2.34h2.95v0.55h-2.95v2.93H124.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.14,52.55v-6.36h4.09v0.55h-3.48v2.28h3.19v0.55h-3.19V52h3.5v0.55H129.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.06,52.55v-5.81h-1.99v-0.55h4.6v0.55h-2v5.81H136.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.5,52.55V50.5l-2.33-4.32h0.69l1.96,3.71l1.96-3.71h0.68l-2.35,4.33v2.03H141.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M147.28,52.55v-6.36h2.4c1.22,0,2.01,0.62,2.01,1.76v0.17c0,1.15-0.8,1.76-2.01,1.76h-1.78v2.66H147.28z  M147.89,49.34h1.77c0.84,0,1.38-0.4,1.38-1.22v-0.17c0-0.82-0.54-1.22-1.38-1.22h-1.77V49.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M152.88,52.55v-6.36h0.62V52h2.88v0.55H152.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M161.72,52.55l-0.71-1.84h-2.96l-0.72,1.84h-0.63l2.51-6.36h0.66l2.5,6.36H161.72z M158.26,50.16h2.54 l-1.26-3.28L158.26,50.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M163.95,52.55v-5.81h-1.99v-0.55h4.6v0.55h-2v5.81H163.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M167.62,52.55v-6.36h3.86v0.55h-3.24v2.34h2.95v0.55h-2.95v2.93H167.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M172.23,49.5v-0.27c0-1.89,1.14-3.15,2.9-3.15s2.9,1.26,2.9,3.15v0.27c0,1.89-1.14,3.15-2.9,3.15 S172.23,51.39,172.23,49.5z M177.4,49.5v-0.27c0-1.55-0.86-2.59-2.27-2.59c-1.42,0-2.27,1.04-2.27,2.59v0.27 c0,1.56,0.85,2.59,2.27,2.59S177.4,51.06,177.4,49.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M179.37,52.55v-6.36h2.49c1.22,0,2.01,0.62,2.01,1.76v0.17c0,1.05-0.65,1.65-1.68,1.75l1.71,2.68h-0.74 l-1.68-2.66h-1.48v2.66H179.37z M179.98,49.34h1.86c0.84,0,1.38-0.4,1.38-1.22v-0.17c0-0.82-0.54-1.22-1.38-1.22h-1.86V49.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M184.97,52.55v-6.36h0.93l2.16,5.6l2.15-5.6h0.93v6.36h-0.62v-5.56l-2.18,5.56h-0.58l-2.18-5.55v5.55H184.97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTetherReHorizLogo2);
export default __webpack_public_path__ + "static/media/TetherREHorizLogo2.6718ff9f678d7691a9866823877718f7.svg";
export { ForwardRef as ReactComponent };